module.exports = __webpack_public_path__ + "media/images/balance-planet-box-8e449a4bcd70c10429331bdf3712b25f.png";